<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I would like to thank my wonderful husband that has fully supported me on my journey to becoming an author. He is amazing and I could not have accomplished this book without him. Special thanks to my mom that has always believed in me and knew that someday I would be a published author. Thanks to all my family for supporting me and encouraging me to never give up on my dreams.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4c7de73c